import styled, { css } from 'styled-components'

const pillStatus = pill => {
    switch (pill) {
        case 'open':
            return css`
                background: #f1f5f9;
                color: #334155;
                .dot {
                    background: #64748b;
                }
            `
        case 'ack':
            return css`
                background: #dbeafe;
                color: #1d4ed8;
                .dot {
                    background: #2563eb;
                }
            `
        case 'progress':
            return css`
                background: #fef3c7;
                color: #b45309;
                .dot {
                    background: #f59e0b;
                }
            `
        case 'resolved':
            return css`
                background: #dcfce7;
                color: #15803d;
                .dot {
                    background: #22c55e;
                }
            `
        case 'escalated':
            return css`
                background: #ffedd5;
                color: #c2410c;
                .dot {
                    background: #f97316;
                }
            `
        case 'hold':
            return css`
                background: #f3e8ff;
                color: #6d28d9;
                .dot {
                    background: #8b5cf6;
                }
            `
        case 'pending':
            return css`
                background: #e0e7ff;
                color: #3730a3;
                .dot {
                    background: #4f46e5;
                }
            `
        case 'cancelled':
            return css`
                background: #f4f4f5;
                color: #52525b;
                .dot {
                    background: #71717a;
                }
            `
        case 'closed':
            return css`
                background: #f4f4f5;
                color: #52525b;
                .dot {
                    background: #71717a;
                }
            `
        default:
            return css`
                background: #f1f5f9;
                color: #334155;
            `
    }
}

const pillPriority = pill => {
    switch (pill) {
        case 'low':
            return css`
                background: #f1f5f9;
                color: #475569;
            `
        case 'medium':
            return css`
                background: #fef3c7;
                color: #b45309;
            `
        case 'high':
            return css`
                background: #fee2e2;
                color: #b91c1c;
            `
        case 'critical':
            return css`
                background: #fecaca;
                color: #7f1d1d;
            `
        default:
            return css`
                background: #fef3c7;
                color: #b45309;
            `
    }
}

export const PageWrap = styled.div`
    margin: ${p => (p.$public ? '0' : '-1rem')};
    min-height: ${p => (p.$public ? 'auto' : 'calc(100vh - 55px)')};
    background: #f7f9fc;
    padding-bottom: 56px;
`

export const PageContent = styled.div`
    max-width: 960px;
    margin: 0 auto;
    padding: 20px 24px 56px;
`

export const BackLink = styled.a`
    color: #64748b;
    font-size: 13px;
    text-decoration: none;
    display: inline-block;
    margin-bottom: 14px;
    cursor: pointer;

    &:hover {
        color: #1f4f9b;
    }
`

export const TicketHeader = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 4px;

    h1 {
        font-size: 22px;
        margin: 0 8px 0 0;
        font-weight: 700;
        color: #0f172a;
    }
`

export const MetaLine = styled.div`
    color: #64748b;
    font-size: 13px;
    margin-bottom: 18px;
`

export const Pill = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.2px;

    .dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        display: inline-block;
    }

    ${p => p.$status && pillStatus(p.$status)}
    ${p => p.$priority && pillPriority(p.$priority)}
    ${p =>
        p.$type &&
        css`
            background: #e8efff;
            color: #1f4f9b;
            font-weight: 700;
        `}
`

export const Card = styled.div`
    background: #fff;
    border: 1px solid #dee5ee;
    border-radius: 10px;
    padding: 16px 18px;
    margin-bottom: 14px;
    box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);

    h3 {
        margin: 0 0 10px;
        font-size: 12px;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        color: #64748b;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
    }
`

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 6px 0;
    gap: 12px;

    .lbl {
        color: #64748b;
        font-size: 13px;
        min-width: 120px;
        flex-shrink: 0;
    }

    .val {
        color: #0f172a;
        font-weight: 500;
        text-align: right;
        flex: 1;
    }
`

export const InlineLink = styled.a`
    color: #1f4f9b;
    text-decoration: none;
    font-weight: 600;

    &:hover {
        text-decoration: underline;
    }
`

export const SlaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    margin: 8px 0;

    .lbl {
        min-width: 130px;
        color: #334155;
        font-size: 13px;
    }
`

export const SlaBar = styled.div`
    flex: 1;
    background: #eef2f7;
    height: 8px;
    border-radius: 6px;
    overflow: hidden;
`

export const SlaFill = styled.div`
    height: 100%;
    border-radius: 6px;
    width: ${p => p.$percent ?? 0}%;
    background: ${p => {
        if (p.$tone === 'danger') return '#ef4444'
        if (p.$tone === 'warn') return '#f59e0b'
        return '#22c55e'
    }};
`

export const SlaTime = styled.div`
    min-width: 170px;
    text-align: right;
    font-size: 13px;
    color: ${p => (p.$overdue ? '#b91c1c' : '#334155')};
    font-weight: 600;
`

export const QuestionText = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: #0f172a;
    line-height: 1.5;
    margin: 4px 0 12px;
`

export const AnswerChip = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: ${p => (p.$negative ? '#fee2e2' : '#dcfce7')};
    color: ${p => (p.$negative ? '#b91c1c' : '#15803d')};
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 700;
    font-size: 13px;
`

export const AssigneeRow = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const AssigneeAvatar = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #1f4f9b;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 13px;
    flex-shrink: 0;
`

export const AssigneeName = styled.div`
    font-weight: 600;
    color: #0f172a;
`

export const AssigneeEmail = styled.div`
    color: #64748b;
    font-size: 13px;
`

export const ActivityItem = styled.div`
    display: flex;
    gap: 10px;
    padding: 8px 0;
    border-top: 1px dashed #dee5ee;

    &:first-of-type {
        border-top: 0;
    }
`

export const ActivityIcon = styled.div`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: #eef2f7;
    color: #64748b;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`

export const ActivityWho = styled.span`
    font-weight: 600;
    font-size: 13px;
`

export const ActivityWhen = styled.span`
    color: #64748b;
    font-size: 12px;
    margin-left: 6px;
`

export const ActivityText = styled.div`
    color: #334155;
    font-size: 13px;
    margin-top: 2px;
    white-space: pre-wrap;
`

export const CommentBox = styled.div`
    margin-top: 12px;

    textarea {
        width: 100%;
        border: 1px solid #dee5ee;
        border-radius: 8px;
        padding: 10px;
        font-family: inherit;
        font-size: 13px;
        min-height: 70px;
        resize: vertical;

        &:focus {
            outline: none;
            border-color: #1f4f9b;
            box-shadow: 0 0 0 3px rgba(31, 79, 155, 0.12);
        }
    }
`

export const CommentActions = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    margin-top: 8px;
    justify-content: flex-end;
`

export const Btn = styled.button`
    border: 1px solid #dee5ee;
    background: #fff;
    color: #334155;
    padding: 8px 14px;
    border-radius: 7px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &:hover:not(:disabled) {
        background: #f7f9fc;
    }

    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }

    ${p =>
        p.$primary &&
        css`
            background: #1f4f9b;
            border-color: #1f4f9b;
            color: #fff;

            &:hover:not(:disabled) {
                background: #163b76;
            }
        `}

    ${p =>
        p.$success &&
        css`
            background: #22c55e;
            border-color: #22c55e;
            color: #fff;

            &:hover:not(:disabled) {
                background: #15803d;
                border-color: #15803d;
            }
        `}
`

export const ActionsBar = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    align-items: center;

    .spacer {
        flex: 1;
    }
`

export const ErrorBanner = styled.div`
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 14px;
    font-size: 14px;
`

export const ExpiredBanner = styled.div`
    background: #fef3c7;
    color: #92400e;
    border: 1px solid #fcd34d;
    border-radius: 8px;
    padding: 16px 18px;
    margin-bottom: 14px;
    font-size: 14px;
    text-align: center;
`

export const PendingBanner = styled.div`
    background: #f5f3ff;
    color: #5b21b6;
    border: 1px solid #ddd6fe;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 14px;
    font-size: 14px;
`

export const PublicBanner = styled.div`
    background: #e8efff;
    color: #1f4f9b;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    padding: 10px 14px;
    margin-bottom: 14px;
    font-size: 13px;
`

export const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 16px;
    align-items: start;

    @media (max-width: 860px) {
        grid-template-columns: 1fr;
    }
`

export const CountBubble = styled.span`
    background: #dbeafe;
    color: #2563eb;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
`

export const Timeline = styled.div`
    position: relative;
    padding-left: 20px;

    &::before {
        content: '';
        position: absolute;
        left: 6px;
        top: 4px;
        bottom: 4px;
        width: 2px;
        background: #e5e7eb;
    }
`

const timelineDot = kind => {
    if (kind === 'created') return '#2563eb'
    if (kind === 'reminded') return '#eab308'
    if (kind === 'escalated') return '#f97316'
    if (kind === 'overdue') return '#dc2626'
    return '#9ca3af'
}

export const TimelineItem = styled.div`
    position: relative;
    margin-bottom: 16px;

    &::before {
        content: '';
        position: absolute;
        left: -20px;
        top: 4px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: ${p => timelineDot(p.$kind)};
        border: 2px solid #fff;
        box-shadow: 0 0 0 2px ${p => timelineDot(p.$kind)};
    }
`

export const TlTitle = styled.div`
    font-weight: 600;
    font-size: 13px;
    color: #0f172a;
`

export const TlMeta = styled.div`
    color: #64748b;
    font-size: 12px;
    margin-top: 2px;
`

export const TlBody = styled.div`
    color: #374151;
    font-size: 13px;
    margin-top: 4px;
    line-height: 1.5;
`

export const WatcherList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const WatcherRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
`

const avatarColors = ['#2563eb', '#8b5cf6', '#0d9488', '#db2777']

export const WatcherAvatar = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${p =>
        p.$external ? '#6b7280' : avatarColors[(p.$index || 0) % avatarColors.length]};
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
`

export const WatcherInfo = styled.div`
    flex: 1;
    min-width: 0;
`

export const WatcherName = styled.div`
    font-weight: 500;
    font-size: 13px;
    color: #0f172a;
`

export const WatcherMeta = styled.div`
    font-size: 11px;
    color: #6b7280;
`

export const NotifyFlags = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 4px;
`

export const NotifyFlag = styled.span`
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 3px;
    background: ${p => (p.$kind === 'escalated' ? '#ffedd5' : '#eff6ff')};
    color: ${p => (p.$kind === 'escalated' ? '#c2410c' : '#2563eb')};
`

export const WatcherRemove = styled.button`
    color: #6b7280;
    cursor: pointer;
    padding: 4px;
    background: none;
    border: none;
    font-size: 14px;

    &:hover {
        color: #dc2626;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`

export const OverdueHint = styled.span`
    color: #dc2626;
    font-size: 12px;
    margin-left: 6px;
`

/** Mockup Screen 4 — Ticket details key/value panel */
export const KvList = styled.dl`
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 8px 12px;
    margin: 0;
    font-size: 13px;

    dt {
        margin: 0;
        color: #64748b;
        padding-top: 2px;
    }

    dd {
        margin: 0;
        color: #0f172a;
        font-weight: 500;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px;
    }

    @media (max-width: 520px) {
        grid-template-columns: 1fr;
        gap: 2px 0;

        dt {
            margin-top: 6px;
        }
    }
`

export const MetaChip = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    background: ${p => {
        if (p.$tone === 'danger') return '#fee2e2'
        if (p.$tone === 'priority') return '#fee2e2'
        if (p.$tone === 'muted') return '#f3f4f6'
        return '#f3f4f6'
    }};
    color: ${p => {
        if (p.$tone === 'danger') return '#ef4444'
        if (p.$tone === 'priority') return '#ef4444'
        if (p.$tone === 'muted') return '#4b5563'
        return '#374151'
    }};
`
